import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useKeycloak } from '@react-keycloak/web';
import Spinner from '../../components/spinner/Spinner';
import KeycloakClient from '../clients/shared/KeycloakClient';

const isMasAuthenticated = (isMasUser, isMasTokenFetched) => !isMasUser || isMasTokenFetched;

const KeycloakTracker = ({ shouldValidateSession, fetchMasToken, isMasTokenFetched, children }) => {
    const { keycloak } = useKeycloak();

    KeycloakClient.setKeycloak(keycloak);

    useEffect(() => {
        if (shouldValidateSession) {
            KeycloakClient.logout();
        }

        if (
            keycloak.authenticated &&
            !isMasAuthenticated(KeycloakClient.isMasUser(), isMasTokenFetched)
        ) {
            fetchMasToken();
        }
    }, [keycloak.authenticated, isMasTokenFetched, shouldValidateSession]);

    return keycloak.authenticated &&
        isMasAuthenticated(KeycloakClient.isMasUser(), isMasTokenFetched) ? (
        children
    ) : (
        <Spinner />
    );
};

KeycloakTracker.defaultProps = {
    shouldValidateSession: false,
    isMasTokenFetched: false,
    fetchMasToken: () => {},
};

KeycloakTracker.propTypes = {
    shouldValidateSession: PropTypes.bool,
    children: PropTypes.node.isRequired,
    fetchMasToken: PropTypes.func,
    isMasTokenFetched: PropTypes.bool,
};

export default KeycloakTracker;
